import React from 'react';
import { Container } from 'reactstrap';
import WSLogo from './ws-logo.png';
import './winter-hero.css';

const WinterHero = () => (
  <div>
    <div className="ws-hero">

      <div className="d-flex justify-content-center align-items-center">
        <h1 className="ws-hero__title m-0">WINTERSENSE</h1>
        <img className="ws-hero__logo" src={WSLogo} alt="Wintersense Logo" />
      </div>
			
      <Container>
        <h4 className="text-center ws-hero__subtitle">An <span className="font-italic">Internet of Things</span> approach to sensing road surface temperatures</h4>
      </Container>

    </div>
    <a className="mx-1 my-0 copyright-link float-right" href="https://www.flickr.com/photos/ucietipa">© Lucy Burtin</a>
  </div>
);

export default WinterHero;



// WEBPACK FOOTER //
// ./src/components/WinterHero/index.js